import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponentComponent } from './loading-component/loading-component.component';

@NgModule({
  imports: [CommonModule],
  declarations: [LoadingComponentComponent],
  exports: [LoadingComponentComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedUiLoadingComponentModule {}
